import { SvgIcon } from '@material-ui/core';
import { FC } from 'react';

import { withStyles, WithStyles } from '@core/theme/utils/with-styles';

import { styles } from './CheckboxPartial.styles';

export type CheckboxPartialIconProps = WithStyles<typeof styles>;

const CheckboxPartialIconComponent: FC<CheckboxPartialIconProps> = ({ classes }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      classes={{ root: classes.root }}
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="currentColor" />
      <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" stroke="currentColor" />
      <path d="M5 8H11" stroke="white" strokeWidth="1.67" strokeLinecap="round" />
    </SvgIcon>
  );
};

export const CheckboxPartialIcon = withStyles(styles)(CheckboxPartialIconComponent);
